import { multipleFileDownload } from 'utils/downloadFile/multipleFileDownload';

import { useSelectableItemsContext } from '..';
import { Button } from '@/shadcn/button';

const useActionHandler = () => {
  const selectedItems = useSelectedItems();

  const { selectableConfig, setIdsCompleted, handleSelectAll } =
    useSelectableItemsContext();

  switch (selectableConfig.action?.type) {
    case 'download':
      return async () => {
        const data = selectedItems.map(item => ({
          digest: item.data.digest,
          key: item.data.key
        }));

        await multipleFileDownload(data);

        setIdsCompleted(selectedItems.map(item => item.id));
        handleSelectAll(false);
      };
    case undefined:
      return () => {
        console.error(`Selectable config action is not defined`);
      };
    default:
      return () => {
        console.error(
          `Selectable config action type "${selectableConfig.action?.type}" is not defined`
        );
      };
  }
};

const reduceValuesByType = type => (previousValues, treeItem) => {
  const value =
    treeItem.type === type && treeItem.selected
      ? [...previousValues, { data: treeItem.data, id: treeItem.id }]
      : previousValues;
  return treeItem.children.reduce(reduceValuesByType(type), value);
};

const getSelectedValuesOfType = (treeValue, type) => {
  const value =
    treeValue.type === type && treeValue.selected
      ? [{ data: treeValue.data, id: treeValue.id }]
      : [];
  return treeValue.children.reduce(reduceValuesByType(type), value);
};

const useSelectedItems = () => {
  const { selectableConfig, treeValue } = useSelectableItemsContext();

  switch (selectableConfig.action?.type) {
    case 'download':
      return getSelectedValuesOfType(treeValue, 'file');
    default:
      return [];
  }
};

export const ActionButton = () => {
  const selectableItemsContext = useSelectableItemsContext();
  // Directly return null if the item is not wrapped within a selectableItems context
  if (!selectableItemsContext) return null;

  const { selectableConfig } = selectableItemsContext;

  const selectedItems = useSelectedItems();
  const isDisabled = !selectedItems?.length;

  const handleClick = useActionHandler();

  return (
    <div>
      <Button
        disabled={isDisabled}
        onClick={handleClick}
        aria-label={selectableConfig.action?.label ?? 'Action'}
      >
        {selectableConfig.action?.label ?? 'Action'}
      </Button>
    </div>
  );
};
